import Vue from 'vue'
import DataService from '@/services/DataService'

export default {
  // current node environment
  env: process.env.NODE_ENV,

  // Settings.
  MockData: {
    "id": 1,
    "user_id": 1,
    "group_id": 1,
    "aggregate": true,
    "consent": true,
    "created_at": "2023-04-24 16:08:25",
    "updated_at": "2023-04-24 16:13:07",
    "deleted_at": null
  },

  getEmailSettings(groupId) {
    if (this.env === 'ci') {
      return Promise.resolve(this.MockData)
    } else {
      return Vue.http.get('activityemailsettings/' + groupId)
    }
  },

  updateEmailSettings(groupId, userId, consent, aggregate) {
    if (this.env === 'ci') {
      return Promise.resolve(this.MockData)
    } else {
      let data = {
        "group_id": groupId,
        "user_id": userId,
        "consent": consent,
        "aggregate": aggregate
      };
      return Vue.http.post('activityemailsettings', data)
    }
  }
}
